import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from './Icon';
import { Table } from './Table';

/**
 * StatusLabel
 */

const Wrapper = styled.div`
  align-items: center;
  border-radius: 6px;
  color: var(--status-text);
  display: inline-flex;
  font-size: var(--small);
  font-weight: var(--bold);
  padding: 4px 12px;
  text-transform: capitalize;

  ${Icon} {
    margin-right: 6px;
  }

  ${({ active }) =>
    active
      ? `
          background: var(--status-active-bg);

          ${Icon} {
            color: var(--status-active);
          }
        `
      : `
          background: var(--status-inactive-bg);

          ${Icon} {
            color: var(--status-inactive);
          }
        `}

  /**
   * Table context
   */

  /* stylelint-disable-next-line no-duplicate-selectors */
  ${Table} & {
    background: none;
    border-radius: 0;
    font-weight: var(--normal);
    padding: 0;
  }
`;

function BaseStatusLabel({ active = false, className, icon, label }) {
  return (
    <Wrapper aria-label={label} active={active} className={className}>
      {icon && <Icon icon={icon} />}
      {label}
    </Wrapper>
  );
}

BaseStatusLabel.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
};

export default styled(BaseStatusLabel)``;

/**
 * ContentStatus
 */

const ARCHIVED = 'ARCHIVED';
const DRAFT = 'DRAFT';
const PUBLISHED = 'PUBLISHED';

const labels = {
  ARCHIVED: 'Archived',
  DRAFT: 'Draft',
  PUBLISHED: 'Live',
};

function BaseContentStatus({ className, published = false, state }) {
  const status = state === ARCHIVED ? ARCHIVED : published ? PUBLISHED : DRAFT;

  const active = status === PUBLISHED;
  const label = labels[status];

  const icon =
    status === PUBLISHED
      ? 'check-circle'
      : status === DRAFT
      ? 'minus-circle'
      : 'circle';

  return (
    <BaseStatusLabel
      active={active}
      className={className}
      icon={icon}
      label={label}
    />
  );
}

BaseContentStatus.propTypes = {
  className: PropTypes.string,
  published: PropTypes.bool,
  state: PropTypes.oneOf([ARCHIVED, DRAFT, PUBLISHED]),
};

export const ContentStatus = styled(BaseContentStatus)``;
